/*eslint-disable*/
import React from "react";
import {
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  return (
    <Flex
      zIndex='3'
      justifyContent='center'
      px={{ base: "30px", md: "50px" }}
      pt='4px'
      pb='10px'>
      <Text
        color={textColor}
        textAlign='center'
        fontWeight='500'>
        ITEQ Digital
      </Text>
    </Flex>
  );
}
